import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import { jsx as _jsx } from "react/jsx-runtime";
import styled from 'styled-components';
import UIModal from 'UIComponents/dialog/UIModal';
export const StyledModal = styled(props => {
  const {
    ModalComponent
  } = props,
        rest = _objectWithoutPropertiesLoose(props, ["hideBackground", "ModalComponent"]);

  return /*#__PURE__*/_jsx(ModalComponent, Object.assign({}, rest));
}).withConfig({
  displayName: "StyledModal",
  componentId: "hiw4vo-0"
})(["&&&{background-color:", ";}"], props => props.hideBackground ? 'transparent' : undefined);
StyledModal.defaultProps = {
  ModalComponent: UIModal
};